var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNasaHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29475",
    "data-name": "Group 29475",
    transform: "translate(-221 -822.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(221 822.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29471",
    "data-name": "Group 29471",
    transform: "translate(-8416.132 11007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-nasa",
    transform: "translate(8654.132 -10176.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50710",
    "data-name": "Path 50710",
    d: "M13.69,5a8.69,8.69,0,1,0,8.69,8.69A8.69,8.69,0,0,0,13.69,5Z",
    transform: "translate(-4.085 -5)",
    fill: "#2a2f96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50711",
    "data-name": "Path 50711",
    d: "M3.73,17.52H3a18.9,18.9,0,0,1,5.913-2.532,47.385,47.385,0,0,0,10.716-4.841A13.785,13.785,0,0,0,22.668,7a11.712,11.712,0,0,1-3.076,4.734c-.5.254-.689.59-1.04.754.058-.065-.044-.4,0-.457A81.524,81.524,0,0,1,8.48,15.585,19.372,19.372,0,0,0,3.73,17.52Z",
    transform: "translate(-3 -6.085)",
    fill: "#e53935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50712",
    "data-name": "Path 50712",
    d: "M17.955,22.929l.687.011L18.29,22.1Zm-.143.524-.125.439.367.2-1.217,0,.378-.212L18,21.318,17.57,21.1h1.449l1.207,2.775.242.214h-1.69l.242-.214-.242-.427h-.966Zm4.643-1.369a1.143,1.143,0,0,1,.845,1.431s-.385,1.132-2.486.456l-.234.228v-.912l.234.228s1.6.6,1.589-.145c0-.146-.276-.386-1.009-.479a.871.871,0,0,1-.815-.973c0-.386.286-1.356,2.342-.685L23.134,21l-.005.9-.207-.2s-1.217-.381-1.338,0C21.455,22.087,22.087,22,22.455,22.084Z",
    transform: "translate(-10.508 -13.68)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50713",
    "data-name": "Path 50713",
    d: "M22.933,17.149a16.428,16.428,0,0,1-2.241,1.88s-6.232,4.027-8.705,5.84A10.284,10.284,0,0,0,9,28.058v-.74a15.509,15.509,0,0,1,3.469-3.173c2.144-1.519,8.551-5.352,9.338-6.607Z",
    transform: "translate(-6.256 -11.592)",
    fill: "#e53935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50714",
    "data-name": "Path 50714",
    d: "M8.667,21.243h1.449l1.207,1.922V21.456l-.242-.214h.966l-.242.214v2.562l.242.214H10.6L9.392,22.311v1.708l.241.214H8.667l.242-.214V21.456Zm11.788,1.838.741,0-.4-.878Zm-.075.5-.151.427.392.214-1.217,0,.378-.212.784-2.562-.428-.214h1.449l1.207,2.775.242.214h-1.69l.242-.214-.242-.427H20.38Z",
    transform: "translate(-6.075 -13.807)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50715",
    "data-name": "Path 50715",
    d: "M22.963,20.35a13.2,13.2,0,0,0-2.169-4.328c-2.2-3.011-4.986-4.7-6.21-3.765-.6.46-.744,1.464-.4,2.827a13.2,13.2,0,0,0,2.169,4.328,11.725,11.725,0,0,0,1.233,1.483l.311.117a15.571,15.571,0,0,1-1.427-1.689,13.032,13.032,0,0,1-2.145-4.276c-.329-1.3-.207-2.249.344-2.671a1.235,1.235,0,0,1,.769-.237c1.349,0,3.475,1.561,5.238,3.972a13.032,13.032,0,0,1,2.145,4.276c.329,1.3.207,2.249-.344,2.671-.74.565-2.106.083-3.558-1.1l-.1.1a5.168,5.168,0,0,0,2.911,1.378,1.336,1.336,0,0,0,.835-.258C23.167,22.718,23.308,21.713,22.963,20.35Z",
    transform: "translate(-8.969 -8.798)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50716",
    "data-name": "Path 50716",
    d: "M.2,0C.089,0,0,.217,0,.484S.089.968.2.968.4.751.4.484.309,0,.2,0Z",
    transform: "translate(8.285 11.745) rotate(-43.348)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50717",
    "data-name": "Path 50717",
    d: "M17.462,7.389l.106.728a.157.157,0,0,0,.133.133l.727.105L17.7,8.46a.157.157,0,0,0-.133.133l-.105.727-.106-.728a.157.157,0,0,0-.133-.133L16.5,8.355l.728-.106a.157.157,0,0,0,.133-.133Zm-4.117,3.2.106.728a.157.157,0,0,0,.133.133l.727.105-.728.106a.157.157,0,0,0-.133.133l-.105.727-.106-.728a.157.157,0,0,0-.133-.133l-.727-.105.728-.106a.157.157,0,0,0,.133-.133ZM13.8,20.2l.106.728a.157.157,0,0,0,.133.133l.727.105-.728.106a.157.157,0,0,0-.133.133l-.105.727L13.7,21.4a.157.157,0,0,0-.133-.133l-.727-.105.728-.106a.157.157,0,0,0,.133-.133Zm8.69-3.2.106.728a.157.157,0,0,0,.133.133l.727.105-.728.106a.157.157,0,0,0-.133.133l-.105.727-.106-.728a.157.157,0,0,0-.133-.133l-.727-.105.728-.106a.157.157,0,0,0,.133-.133ZM21.578,19.1a.229.229,0,1,0,.229.229A.229.229,0,0,0,21.578,19.1ZM10.6,18.646a.229.229,0,1,0,.229.229A.229.229,0,0,0,10.6,18.646Zm-1.372-.915a.229.229,0,1,0,.229.229A.229.229,0,0,0,9.229,17.731Zm6.861-8.69a.229.229,0,1,0,.229.229A.229.229,0,0,0,16.09,9.041Zm-1.83,3.2a.229.229,0,1,0,.229.229A.229.229,0,0,0,14.26,12.242Z",
    transform: "translate(-6.256 -6.296)",
    fill: "#fafafa"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNasaHighlighted);
export default __webpack_public_path__ + "static/media/nasaHighlighted.a380af81562409bc08a924edfa942869.svg";
export { ForwardRef as ReactComponent };